<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel modal__panel--profile">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
            </div>

            <div class="modal__main-icon modal__main-icon--user"></div>
            <div class="modal__back" @click="goBack()"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form">
                <div class="navigators">
                    <div class="navigator" @click="currentPage > 0 ? goTo(0) : null" :class="{
                        'navigator--active':
                            currentPage === 0 ||
                            currentPage === 1 ||
                            currentPage === 2,
                    }">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addUserModal.${"details"}`) }}
                        </div>
                    </div>

                    <div class="navigator" @click="goTo(1)" :class="{
                        'navigator--active':
                            currentPage === 1 ||
                            currentPage === 2,
                    }">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addUserModal.${"contact"}`) }}
                        </div>
                    </div>

                    <div class="navigator" @click="goTo(2)" :class="{ 'navigator--active': currentPage === 2 }">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addUserModal.${"image"}`) }}
                        </div>
                    </div>
                </div>

                <form class="add__form" :class="{ 'add__form--expanded': currentPage === 2 }">
                    <transition name="fade" mode="out-in">
                        <Loading v-if="formLoading" />
                        <div v-else class="add__content">
                            <transition name="fade" mode="out-in">
                                <div class="details" key="0" v-if="currentPage === 0">
                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <VSelect :options="genders" :reduce="(gender) => gender.id"
                                                :placeholder="$t(`addPrivateCostumerModal.gender`)" label="name"
                                                v-model="userDetails.gender" class="select select--default"
                                                :class="{ 'select--error': genderHasError }" />
                                            <div class="form__error" v-if="genderHasError">
                                                {{ $t(`addUserModal.${"genderErrorMsg"}`) }}
                                            </div>
                                        </div>

                                        <div class="form__field form__field--double">
                                            <VSelect :options="titles" :reduce="(title) => title.id"
                                                :placeholder="$t(`addPrivateCostumerModal.title`)" label="name"
                                                v-model="userDetails.titleId" class="select select--default" />
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.firstName`)"
                                            v-model="userDetails.firstName" :class="{ 'input--error': firstNameHasError }" />
                                        <div class="form__error" v-if="firstNameHasError">
                                            {{ firstNameErrorPlaceholder }}
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.lastName`)"
                                            v-model="userDetails.lastName" :class="{ 'input--error': lastNameHasError }" />
                                        <div class="form__error" v-if="lastNameHasError">
                                            {{ lastNameErrorPlaceholder }}
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <Datepicker class="input input--default" :class="{ 'input--error': birthdayHasError }"
                                                :config="statics.datePickerConfig"
                                                :placeholder="$t(`addPrivateCostumerModal.birthdate`)"
                                                v-model="userDetails.birthday" />
                                            <div class="form__error" v-if="birthdayHasError">
                                                {{ $t(`addUserModal.${"birthdateErrorMsg"}`) }}
                                            </div>
                                        </div>

                                        <div class="form__field form__field--double">
                                            <VSelect :options="languages" :reduce="(language) => language.id"
                                                :placeholder="$t(`addPrivateCostumerModal.language`)" label="name"
                                                v-model="userDetails.language" class="select select--default"
                                                :class="{ 'select--error': languageHasError }" />
                                            <div class="form__error" v-if="languageHasError">
                                                {{ $t(`addUserModal.${"languageErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t(`addPrivateCostumerModal.street`)"
                                                v-model="userAddress[0].street"
                                                :class="{ 'input--error': streetHasError }" />
                                            <div class="form__error" v-if="streetHasError">
                                                {{ $t(`addPrivateCostumerModal.${"streetErrorMsg"}`) }}
                                            </div>
                                        </div>
                                        <div class="form__field form__field--double form__field--nr">
                                            <input type="text" class="input input--default" placeholder="Nr."
                                                v-model="userAddress[0].number"
                                                :class="{ 'input--error': numberHasError }" />
                                            <div class="form__error" v-if="numberHasError">
                                                {{ $t(`addPrivateCostumerModal.${"numberErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t(`addPrivateCostumerModal.zip`)"
                                                v-model="userAddress[0].zip" :class="{ 'input--error': zipHasError }" />
                                            <div class="form__error" v-if="zipHasError">
                                                {{ zipCodePlaceholder }}
                                            </div>
                                        </div>

                                        <div class="form__field form__field--double">
                                            <VSelect v-if="zipCodeData.length > 1" :options="zipCodeData"
                                                :reduce="(city) => city.city"
                                                :placeholder="$t(`addPrivateCostumerModal.city`)" label="city"
                                                v-model="userAddress[0].city" class="select select--default"
                                                :class="{ 'input--error': cityHasError }" />

                                            <div v-else-if="zipCodeData.length"
                                                class="input input--default input--readonly"
                                                :class="{ 'input--error': cityHasError }">
                                                {{ userAddress[0].city }}
                                            </div>

                                            <input v-else-if="!zipCodeData.length" type="text"
                                                class="input input--default"
                                                :placeholder="$t(`addPrivateCostumerModal.city`)"
                                                v-model="userAddress[0].city"
                                                :class="{ 'input--error': cityHasError }" />

                                            <div class="form__error" v-if="cityHasError">
                                                {{ $t(`addUserModal.${"cityErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="contact" key="1" v-else-if="currentPage === 1">
                                    <div class="form__field">
                                        <input type="text" class="input input--default" placeholder="E-mail *"
                                            v-model="userContact.email" :class="{ 'input--error': emailHasError }" />
                                        <div class="form__error" v-if="emailHasError">
                                            {{ emailPlaceholder }}
                                        </div>
                                    </div>

                                    <div class="form__field form__field--prefix">
                                        <div class="form__row">
                                            <div class="form__input-wrapper">
                                                <input type="text" class="input input--default"
                                                    :placeholder="$t(`addPrivateCostumerModal.phone`)"
                                                    v-model="userContact.phone"
                                                    :class="{ 'input--error': phoneHasError }" />
                                                <div class="form__error" v-if="phoneHasError">
                                                    {{ phoneErrorPlaceholder }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <VSelect :options="countries" :reduce="(country) => country.code"
                                            :placeholder="$t(`addPrivateCostumerModal.nationality`)" label="name"
                                            v-model="userContact.countryCode" class="select select--default" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default" placeholder="AHV Nr."
                                            v-model="userContact.ahvNr" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.bank`)"
                                            v-model="userBanks[0].name" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.account`)"
                                            v-model="userBanks[0].account" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default" placeholder="Finma Nr."
                                            v-model="userContact.finmaNr" />
                                    </div>
                                </div>

                                <div class="logo" key="2" v-else-if="currentPage === 2">
                                    <div class="add__avatar">
                                        <img v-if="userImage" :src="userImage" alt="" ref="userImageRef" />
                                        <div v-else class="add__avatar-empty">
                                            <img class="add__avatar-empty"
                                                src="../assets/icons/default/Bold 2px-profile_circled-white.svg"
                                                alt="" />
                                        </div>
                                    </div>
                                    <div class="add__upload-text">
                                        {{ $t(`addPrivateCostumerModal.${"uploadImg"}`) }}
                                    </div>
                                    <div class="add__upload-wrapper">
                                        <button type="button" class="button button--default button--upload"
                                            @click="uploadFileRef?.click()">
                                            {{ $t(`addPrivateCostumerModal.${"uploadImg"}`) }}
                                        </button>
                                        <input ref="uploadFileRef" type="file" class="add__upload"
                                            @change="uploadImage($event)" />
                                    </div>

                                    <div class="signature">
                                        <div v-if="isProfileEdit && !editingUser?.hasSignature" class="user_signature">
                                            <div class="add__upload-text">
                                                {{ $t(`customerSignature.${"formTitle"}`) }} :
                                            </div>

                                            <VueSignaturePad ref="signaturePadRef" class="signature-canvas"
                                                width="600px" height="300px" />

                                            <button type="button" class="button button--default clear-btn"
                                                @click="clearSignature">
                                                {{ $t(`customerSignature.${"clearBtn"}`) }}
                                            </button>
                                        </div>
                                        <div v-else-if="isProfileEdit && editingUser?.hasSignature">
                                            <button type="button" class="button button--default clear-btn"
                                                @click="resetSignature">
                                                {{ $t(`customerSignature.${"resetBtn"}`) }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </transition>
                </form>
            </div>

            <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
            <button v-else type="button" class="modal__button modal__button--submit button button--default"
                @click="currentPage !== 2 ? goForward() : saveProfile()">
                <span v-if="currentPage === 2">{{ $t(`addUserModal.${"saveBtn"}`) }}</span>
                <span v-else>{{ $t(`addUserModal.${"next"}`) }}</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Loading from "@/partials/Loading";
import statics from "@/statics";
import parseFieldErrors from "@/helpers/parseFieldErrors";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();
defineOptions({ name: "ProfileModal" });

const store = useStore();

const uploadFileRef = ref(null);
const signaturePadRef = ref(null);
const userImageRef = ref(null);

const currentPage = ref(0);
const editingUser = ref(null);
const file = ref("");
const userImage = ref("");
const formLoading = ref(false);
const isRequesting = ref(false);
const specificErrors = ref([]);

const firstNameHasError = ref(false);
const lastNameHasError = ref(false);
const genderHasError = ref(false);
const birthdayHasError = ref(false);
const languageHasError = ref(false);
const streetHasError = ref(false);
const numberHasError = ref(false);
const zipHasError = ref(false);
const cityHasError = ref(false);
const emailHasError = ref(false);
const phoneHasError = ref(false);

const zipCodePlaceholder = ref("");
const emailPlaceholder = ref("");
const firstNameErrorPlaceholder = ref("");
const lastNameErrorPlaceholder = ref("");
const phoneErrorPlaceholder = ref("");

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const userDetails = reactive({
    gender: "",
    titleId: "",
    firstName: "",
    lastName: "",
    birthday: "",
    language: "",
});

const userContact = reactive({
    email: "",
    phone: "",
    countryCode: "",
    ahvNr: "",
    finmaNr: "",
});

const userAddress = reactive([{ street: "", number: "", city: "", zip: "" }]);
const userBanks = reactive([{ name: "", account: "" }]);

const userForms = computed(() => store.getters.userForms);
const isProfileEdit = computed(() => store.getters.isProfileEdit);
const genders = computed(() => userForms.value ? userForms.value.genders : []);
const titles = computed(() => userForms.value ? userForms.value.titles : []);
const languages = computed(() => userForms.value ? userForms.value.languages : []);
const countries = computed(() => userForms.value ? userForms.value.countries : []);

const zipCodeData = computed({
    get() {
        return store.state.zipCodes.zipCodeData;
    },
    set(value) {
        store.commit("setZipCodeData", value);
    },
});

const zip = computed(() => userAddress[0].zip);
const city = computed(() => userAddress[0].city);

const loadCities = async (value) => {
    await store.dispatch("getZipCodeData", value);
    userAddress[0].zip = value;
    userAddress[0].city = zipCodeData.value[0]?.city || "";
};

const validateUserDetails = (callback) => {
    const { firstName, lastName, gender, language } = userDetails;
    const { zip: zipValue, city: cityValue, street, number } = userAddress[0];

    if (!firstName) {
        firstNameHasError.value = true;
        firstNameErrorPlaceholder.value = t(`addPrivateCostumerModal.${"firstNameErrorMsg"}`);
    } else {
        firstNameHasError.value = false;
        firstNameErrorPlaceholder.value = "";
    }

    if (!lastName) {
        lastNameHasError.value = true;
        lastNameErrorPlaceholder.value = t(`addPrivateCostumerModal.${"lastNameErrorMsg"}`);
    } else {
        lastNameHasError.value = false;
        lastNameErrorPlaceholder.value = "";
    }

    genderHasError.value = !gender;
    languageHasError.value = !language;
    streetHasError.value = !street;
    numberHasError.value = !number;
    zipHasError.value = !zipValue;
    cityHasError.value = !cityValue;

    if (!zipValue) {
        zipCodePlaceholder.value = t(`addCompanyContactModal.${"zipErrorMsg"}`);
    }

    if (
        !firstNameHasError.value &&
        !lastNameHasError.value &&
        !birthdayHasError.value &&
        !genderHasError.value &&
        !languageHasError.value &&
        !streetHasError.value &&
        !numberHasError.value &&
        !zipHasError.value &&
        !cityHasError.value
    ) {
        callback(true);
    }
};

const validateUserContact = (callback) => {
    const { email, phone } = userContact;

    if (!email) {
        emailHasError.value = true;
        emailPlaceholder.value = t(`addPrivateCostumerModal.${"emailRequired"}`);
    }

    if (!phone) {
        phoneHasError.value = true;
        phoneErrorPlaceholder.value = t(`addPrivateCostumerModal.${"phoneRequired"}`);
    }

    if (!emailHasError.value && !phoneHasError.value) {
        callback(true);
    }
};

watch(() => userDetails.gender, (value) => {
    genderHasError.value = !value;
});

watch(() => userDetails.firstName, (value) => {
    if (value) {
        firstNameHasError.value = false;
        firstNameErrorPlaceholder.value = "";
    } else {
        firstNameHasError.value = true;
        firstNameErrorPlaceholder.value = t(`addPrivateCostumerModal.${"firstNameErrorMsg"}`);
    }
});

watch(() => userDetails.lastName, (value) => {
    if (value) {
        lastNameHasError.value = false;
        lastNameErrorPlaceholder.value = "";
    } else {
        lastNameHasError.value = true;
        lastNameErrorPlaceholder.value = t(`addPrivateCostumerModal.${"lastNameErrorMsg"}`);
    }
});

watch(() => userDetails.language, (value) => {
    languageHasError.value = !value;
});

watch(() => userAddress[0].street, (value) => {
    streetHasError.value = !value;
});

watch(() => userAddress[0].number, (value) => {
    numberHasError.value = !value;
});

watch(zip, async (newZip) => {
    if (newZip) {
        zipHasError.value = false;
        zipCodePlaceholder.value = "";

        if (newZip >= 1000 && newZip <= 9999) {
            await loadCities(newZip);
        } else {
            zipCodeData.value = [];
            userAddress[0].city = "";
            zipHasError.value = true;
            zipCodePlaceholder.value = t(`addPrivateCostumerModal.${"invalidZip"}`);
        }
    } else {
        userAddress[0].city = "";
        zipHasError.value = true;
        zipCodePlaceholder.value = t(`addCompanyContactModal.${"zipErrorMsg"}`);
    }
});

watch(city, (value) => {
    cityHasError.value = !value;
});

watch(() => userContact.email, (value) => {
    if (value) {
        emailHasError.value = false;
        emailPlaceholder.value = "";

        if (!emailRegex.test(value.toLowerCase())) {
            emailHasError.value = true;
            emailPlaceholder.value = t(`addPrivateCostumerModal.${"invalidEmail"}`);
        }
    } else {
        emailHasError.value = true;
        emailPlaceholder.value = t(`addPrivateCostumerModal.${"emailRequired"}`);
    }
});

watch(() => userContact.phone, (value) => {
    if (value) {
        if (!statics.phoneRegex.test(value)) {
            phoneHasError.value = true;
            phoneErrorPlaceholder.value = t(`addPrivateCostumerModal.${"invalidPhone"}`);
        } else {
            phoneHasError.value = false;
            phoneErrorPlaceholder.value = "";
        }
    } else {
        phoneHasError.value = true;
        phoneErrorPlaceholder.value = t(`addPrivateCostumerModal.${"phoneRequired"}`);
    }
});

watch(specificErrors, (errors) => {
    const errorKeys = errors.map((error) => error.errorKey);

    if (errorKeys.includes("email")) {
        currentPage.value = 1;
        emailHasError.value = true;
        emailPlaceholder.value = errors.find((error) => error.errorKey === "email").errorValue;
    } else {
        emailHasError.value = false;
        emailPlaceholder.value = "";
    }

    if (errorKeys.includes("phone")) {
        currentPage.value = 1;
        phoneHasError.value = true;
        phoneErrorPlaceholder.value = errors.find((error) => error.errorKey === "phone").errorValue;
    } else {
        phoneHasError.value = false;
        phoneErrorPlaceholder.value = "";
    }

    if (errorKeys.includes("first_name")) {
        currentPage.value = 0;
        firstNameErrorPlaceholder.value = errors.find((error) => error.errorKey === "first_name").errorValue;
        firstNameHasError.value = true;
    } else {
        firstNameHasError.value = false;
        firstNameErrorPlaceholder.value = "";
    }

    if (errorKeys.includes("last_name")) {
        currentPage.value = 0;
        lastNameErrorPlaceholder.value = errors.find((error) => error.errorKey === "last_name").errorValue;
        lastNameHasError.value = true;
    } else {
        lastNameHasError.value = false;
        lastNameErrorPlaceholder.value = "";
    }
});

const closeModal = () => {
    store.commit("setShowProfileModal", false);
    zipCodeData.value = [];
};

const loadFieldsForEdit = (userToEditData) => {
    const {
        company_name,
        ahv_number,
        finma_nr,
        birthday,
        country,
        email,
        first_name,
        gender,
        language,
        last_name,
        phone,
        prefix,
        photo,
        title,
        user_addresses = [],
        user_banks = [],
    } = userToEditData || {};

    userDetails.firstName = first_name || "";
    userDetails.lastName = last_name || "";
    userDetails.gender = gender?.id || "";
    userDetails.language = language?.id || "";
    userDetails.titleId = title?.id || "";
    userDetails.birthday = birthday || "";

    userContact.email = email || "";
    userContact.phone = phone || "";
    userContact.countryCode = country?.code || "";
    userContact.ahvNr = ahv_number || "";
    userContact.finmaNr = finma_nr || "";
    userImage.value = photo?.thumbnail || "";

    userAddress[0] = {
        id: user_addresses[0]?.id || "",
        street: user_addresses[0]?.street || "",
        number: user_addresses[0]?.number || "",
        city: user_addresses[0]?.city || "",
        zip: user_addresses[0]?.zip || "",
    };

    userBanks[0] = {
        id: user_banks[0]?.id || "",
        name: user_banks[0]?.name || "",
        account: user_banks[0]?.account || "",
    };

    userDetails.company = !!company_name;
    userDetails.companyName = company_name || "";
    userContact.phonePrefix = prefix || "";
};

const base64ToFile = (base64String, filename) => {
    try {
        const base64Data = base64String.includes(",") ? base64String.split(",")[1] : base64String;
        const binary = atob(base64Data);
        const bytes = new Uint8Array(binary.length);

        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: "image/png" });
        return Promise.resolve(new File([blob], filename, { type: "image/png" }));
    } catch (error) {
        console.error("Error converting base64 to file:", error);
        return Promise.resolve(null);
    }
};

const getSignatureFile = async () => {
    if (!isProfileEdit.value || !signaturePadRef.value) return null;

    const { isEmpty, data } = signaturePadRef.value.saveSignature();
    if (isEmpty) return null;

    return await base64ToFile(data, "signature.png");
};

const clearSignature = () => {
    signaturePadRef.value?.clearSignature();
};

const resetSignature = async () => {
    formLoading.value = true;
    await store.dispatch("resetUserSignature", { userId: editingUser.value.id });
    const user = await store.dispatch("getProfile");
    editingUser.value = user;
    loadFieldsForEdit(user);
    formLoading.value = false;
};

const goBack = () => {
    currentPage.value--;
    if (currentPage.value < 0) {
        closeModal();
    }
};

const goTo = (page) => {
    if (page === 1) {
        validateUserDetails((state) => {
            if (state) currentPage.value = page;
        });
        return;
    }

    if (page === 2) {
        validateUserDetails((detailsState) => {
            validateUserContact((contactState) => {
                if (detailsState && contactState) currentPage.value = page;
            });
        });
        return;
    }

    currentPage.value = page;
};

const goForward = () => {
    if (currentPage.value === 0) {
        validateUserDetails((state) => {
            if (state) currentPage.value++;
        });
        return;
    }

    if (currentPage.value === 1) {
        validateUserContact((state) => {
            if (state) currentPage.value++;
        });
    }
};

const saveProfile = async () => {
    isRequesting.value = true;

    const user = {
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userContact.email,
        titleId: userDetails.titleId,
        gender: userDetails.gender,
        countryCode: userContact.countryCode,
        birthday: userDetails.birthday,
        phone: userContact.phone,
        prefix: userContact.phonePrefix,
        ahvNr: userContact.ahvNr,
        finmaNr: userContact.finmaNr,
        language: userDetails.language,
        file: file.value,
        user_addresses: userAddress,
        user_banks: userBanks,
        settings: {
            locale: languages.value.find((lang) => lang.id === userDetails.language)?.code,
        },
    };

    try {
        const signatureFile = isProfileEdit.value ? await getSignatureFile() : null;
        const response = await store.dispatch("updateProfile", {
            user: { ...user, signature: signatureFile },
        });

        store.commit("setUser", response);

        const selectedLanguageCode = languages.value.find((lang) => Number(lang.id) === Number(userDetails.language))?.code || "de";
        const currentUser = store.getters.loggedUser || {};
        const updatedLoggedUser = {
            ...currentUser,
            language: selectedLanguageCode,
            settings: {
                ...(currentUser.settings || {}),
                locale: selectedLanguageCode,
            },
        };

        localStorage.setItem("language", selectedLanguageCode);
        localStorage.setItem("user", JSON.stringify(updatedLoggedUser));
        store.commit("setLanguage", selectedLanguageCode);
        store.commit("setLoggedUser", updatedLoggedUser);
        locale.value = selectedLanguageCode;

        closeModal();
    } catch (err) {
        const errors = err.response?.data?.errors || [];
        specificErrors.value = parseFieldErrors(errors);
    } finally {
        isRequesting.value = false;
    }
};

const uploadImage = (event) => {
    file.value = event.target.files[0];
    userImage.value = URL.createObjectURL(file.value);
};

onMounted(async () => {
    try {
        formLoading.value = true;

        if (isProfileEdit.value) {
            const user = await store.dispatch("getProfile");
            await store.dispatch("getProfileForms");
            editingUser.value = user;
            loadFieldsForEdit(user);
        } else {
            await store.dispatch("getProfileForms");
        }
    } catch (error) {
        console.error("Error loading profile form data:", error);
    } finally {
        formLoading.value = false;
    }
});
</script>

<style lang="scss" scoped>
.add__form {
    width: 400px !important;
}

.modal__panel--profile {
    height: 770px !important;
}

.add__form--expanded {
    width: 650px !important;
}

.user_signature {
    margin-top: 20px;
    text-align: center;
    width: 100%;
}

.signature-canvas {
    border-radius: 10px;
    box-shadow: 0px 7px 18px var(--shadow-2);
    width: 100%;
}

.clear-btn {
    width: 200px !important;
    margin: 0 auto;
    margin-top: 20px;
}

.modal .navigators {
    width: 500px;
}
</style>
